export default __webpack_public_path__ + "static/media/Alessandra-Keiko-Aoki-Diretora-Executiva.cf733078.png";